import React from 'react';
import { Page } from '../../components/Routing/Page';
import { ImageBlock } from '../../components/Blocks/ImageBlock';

import bg from "../../assets/dev.jpg"
import hello from "../../assets/phone-hello.png"
import corporative from "../../assets/corporative.png"
import admin from "../../assets/admin.png"
import { Breakpoint } from '../../components/Breakpoint/Breakpoint';
// import { ItemParallax } from '../../components/CustomParallax/ItemParallax';
import { ItemParallax } from './../../components/Parallax/ItemParallax';
import "./dev.scss";
export class Dev extends React.PureComponent
{
	
	render()
	{
		return (
			// <Page id="dev" title="System3" noCrawl >
			<div id="dev" >
				<ImageBlock overlay src={bg} >
					<h2>Tu oficina y escaparate <span className="highlight">en la <span>Nube</span></span></h2>
					<h3>Desarrollo web</h3>
					<p>
						Da el salto a un futuro más cómodo y seguro con tu software de gestión personalizado en la nube. Completamente adaptado a tu forma de trabajar, y disponible siempre, estes donde estes{'\n\n'}
						Mejora tu presencia en la red con una web moderna, perfecta tanto en móvil como en ordenador, usando las ultimas tecnologías.{'\n\n'}
					</p>
					<Breakpoint medium up>
						<ItemParallax id="dev-img" speed={.6} >
							<img  src={hello}  />
						</ItemParallax>
					</Breakpoint>
					<Breakpoint medium up>
						<ItemParallax  id="custom" speed={.6} >
							<img src={admin}  />
						</ItemParallax>
					</Breakpoint>
					<ItemParallax medium up className="titled-list" speed={.1} >
						<h3>
							Software a medida
						</h3>
						<ul>
							<li>
								Siempre disponible, desde cualquier dispositivo
							</li>
							<li>
								Máxima seguridad para tus datos
							</li>
							<li>
								Adaptado a tus necesidades
							</li>
						</ul>
					</ItemParallax>
					<Breakpoint medium up>
						<ItemParallax id="web" speed={.6} >
							<img  src={corporative}  />
						</ItemParallax>
					</Breakpoint>
					<ItemParallax medium up className="titled-list" speed={.1} >
						<h3>
							web corporativa
						</h3>
						<ul>
							<li>
								Imagen premium y moderna
							</li>
							<li>
								Perfecta en cualquier dispositivo
							</li>
							<li>
							 	Disponible incluso sin conexión
							</li>
						</ul>
					</ItemParallax>
				</ImageBlock>
			</div>
		);
	}
}